module.exports = __webpack_public_path__ + "img/Manufacturing.8bdc9cd1.svg";